<div #legendSymbol (click)="changeSymbol()"></div>
